// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2tkMh","title":"InfoRow_title__2TEKJ"};